import $ from "jquery/dist/jquery";

$(() => {
    function loadFacetCategoryData(s, preselect = false) {
        s = $(s);
        let data = `tag_pk=${s.attr('data-facet-category-pk')}&ff_pk=${s.attr('data-facet-pk')}`;

        if (preselect) {
            s.find("[data-facet-select]").each(function () {
                data += `&${$(this).attr('name')}=${$(this).attr('data-facet-select')}`;
            });
            s.find('select').prop('disabled', 'disabled').html('<option value="">- Vše -</option>');
        } else {
            s.find("[data-facet-select]").each(function () {
                data += `&${$(this).attr('name')}=${$(this).val()}`;
                $(this).prop('disabled', 'disabled').attr('data-facet-select', $(this).val());
            });
        }

        $.ajax({
            'url': window.NXURLS.URL_ESHOP_GET_FACET_CATEGORY_DATA,
            'data': data
        }).done((data) => {
            for (const [k, v] of Object.entries(data)) {
                let i = 0;
                s.find(`[data-facet-pk='${k}']`).each(function () {
                    const e = $(this);

                    if (i < v.length) {
                        if (e.is("select")) {
                            const preselect_value = e.attr('data-facet-select');
                            e.html('<option value="">- Vše -</option>');
                            let something_there = false;

                            for (const x of v[i]) {
                                let selected = '';
                                if (`${x[0]}` == `${preselect_value}`) {
                                    selected = "selected";
                                }

                                const o = $(`<option value='${x[0]}' ${selected}></option>`);
                                o.html(x[1]);
                                e.append(o);
                                something_there = true;
                            }

                            if (something_there) {
                                e.prop('disabled', false);
                            }
                        }
                    }
                    i++;
                });
            }
        });
    }

    function loadFacetData(s, preselect = false) {
        s = $(s);
        let data = `fp_pk=${s.attr('data-facet-page-pk')}`;

        if (preselect) {
            s.find("[data-facet-select]").each(function () {
                data += `&${$(this).attr('name')}=${$(this).attr('data-facet-select')}`;
            });
            s.find('select').prop('disabled', 'disabled').html('<option value="">- Vše -</option>');

        } else {
            data += `&${s.serialize()}`;
            s.find("[data-facet-select]").each(function () {
                $(this).prop('disabled', 'disabled').attr('data-facet-select', $(this).val());
            });
        }

        $.ajax({
            'url': window.NXURLS.URL_ESHOP_GET_FACET_DATA,
            'data': data
        }).done((data) => {
            for (const [k, v] of Object.entries(data)) {
                let i = 0;
                s.find(`[data-facet-pk='${k}']`).each(function () {
                    const e = $(this);

                    if (i < v.length) {
                        if (e.is("select")) {
                            const preselect_value = e.attr('data-facet-select');
                            e.html('<option value="">- Vše -</option>');
                            let something_there = false;

                            for (const x of v[i]) {
                                let selected = '';
                                if (`${x[0]}` == `${preselect_value}`) {
                                    selected = "selected";
                                }

                                const o = $(`<option value='${x[0]}' ${selected}></option>`);
                                o.html(x[1]);
                                e.append(o);
                                something_there = true;
                            }

                            if (something_there) {
                                e.prop('disabled', false);
                            }
                        }
                    }
                    i++;
                });
            }
        });
    }

    $(() => {
        function unselectChilds(f) {
            const my_id = $(f).attr('id');
            f.find(`select[data-facet-parent='${my_id}']`).each(function () {
                $(this).val('');
                unselectChilds.call(this, f);
            });
        }

        $('[data-facet="page"]').on('change', 'select', function (e) {
            let f = $(e.target).closest('[data-facet="page"]');
            unselectChilds.call(e.target, f);
            loadFacetData(f, false);
        });

        $('[data-facet="page"]').each(function () {
            loadFacetData(this, true);
        });

        $('[data-facet="category"]').on('change', 'select', (e) => {
            let f = $(e.target).closest('[data-facet="category"]');
            unselectChilds.call(e.target, f);
            loadFacetCategoryData(f, false);
        });

        $('[data-facet="category"]').each(function () {
            loadFacetCategoryData(this, true);
        });
    });
});
